import { createClass as _createClass, classCallCheck as _classCallCheck } from './_virtual/_rollupPluginBabelHelpers.mjs';

/** @tossdocs-ignore */
var MemoStorage = /*#__PURE__*/function () {
  function MemoStorage() {
    _classCallCheck(this, MemoStorage);

    this.storage = new Map();
  }

  _createClass(MemoStorage, [{
    key: "get",
    value: function get(key) {
      return this.storage.get(key) || null;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this.storage.set(key, value);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      this.storage["delete"](key);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.storage.clear();
    }
  }]);

  return MemoStorage;
}();

var LocalStorage = /*#__PURE__*/function () {
  function LocalStorage() {
    _classCallCheck(this, LocalStorage);
  }

  _createClass(LocalStorage, [{
    key: "get",
    value: function get(key) {
      return localStorage.getItem(key);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      localStorage.setItem(key, value);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      localStorage.removeItem(key);
    }
  }, {
    key: "clear",
    value: function clear() {
      localStorage.clear();
    }
  }], [{
    key: "canUse",
    value: function canUse() {
      var TEST_KEY = generateTestKey(); // 사용자가 쿠키 차단을 하는 경우 LocalStorage '접근' 시에 예외가 발생합니다.

      try {
        localStorage.setItem(TEST_KEY, 'test');
        localStorage.removeItem(TEST_KEY);
        return true;
      } catch (err) {
        return false;
      }
    }
  }]);

  return LocalStorage;
}();

var SessionStorage = /*#__PURE__*/function () {
  function SessionStorage() {
    _classCallCheck(this, SessionStorage);
  }

  _createClass(SessionStorage, [{
    key: "get",
    value: function get(key) {
      return sessionStorage.getItem(key);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      sessionStorage.setItem(key, value);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      sessionStorage.removeItem(key);
    }
  }, {
    key: "clear",
    value: function clear() {
      sessionStorage.clear();
    }
  }], [{
    key: "canUse",
    value: function canUse() {
      var TEST_KEY = generateTestKey(); // sessionStorage를 사용할 수 없는 경우에 대응합니다.

      try {
        sessionStorage.setItem(TEST_KEY, 'test');
        sessionStorage.removeItem(TEST_KEY);
        return true;
      } catch (err) {
        return false;
      }
    }
  }]);

  return SessionStorage;
}();

function generateTestKey() {
  return new Array(4).fill(null).map(function () {
    return Math.random().toString(36).slice(2);
  }).join('');
}

function generateStorage() {
  if (LocalStorage.canUse()) {
    return new LocalStorage();
  }

  return new MemoStorage();
}
function generateSessionStorage() {
  if (SessionStorage.canUse()) {
    return new SessionStorage();
  }

  return new MemoStorage();
}
var safeLocalStorage = generateStorage();
var safeSessionStorage = generateSessionStorage();

export { generateSessionStorage, generateStorage, safeLocalStorage, safeSessionStorage };
